module.exports = __webpack_public_path__ + "img/ilu_portada.c6a8b86e.svg";